import axios from 'axios';
import config from '../config.json';

// Public API - no auth required. Session UUID in URL IS the auth.
const baseUrl = config.prod ? 'https://api.itpscorp.com' : 'https://api.itpscorp.com/dev';
const PUBLIC_BASE = `${baseUrl}/public/crm`;

const publicApi = axios.create({
  baseURL: PUBLIC_BASE,
  headers: { 'Content-Type': 'application/json' },
});

export interface SupportSession {
  uuid: string;
  customer_name: string;
  status: string;
  expires_at: string;
  created_at: string;
}

export interface ChatMessage {
  pk: number;
  session_id: number;
  sender_type: string;
  sender_name: string;
  sender_id: number | null;
  content: string;
  message_type: string;
  created_at: string;
}

export const getSupportSession = async (uuid: string): Promise<SupportSession> => {
  const response = await publicApi.get(`/support/${uuid}`);
  return response.data.result;
};

export const joinSession = async (uuid: string): Promise<SupportSession> => {
  const response = await publicApi.post(`/support/${uuid}/join`);
  return response.data.result;
};

export const getMessages = async (uuid: string, afterId?: number): Promise<ChatMessage[]> => {
  const params = afterId ? `?after_id=${afterId}` : '';
  const response = await publicApi.get(`/support/${uuid}/messages${params}`);
  return response.data.result;
};

export const sendMessage = async (uuid: string, content: string, senderName: string): Promise<ChatMessage> => {
  const response = await publicApi.post(`/support/${uuid}/messages`, { content, sender_name: senderName });
  return response.data.result;
};

export const submitRustdeskId = async (uuid: string, rustdeskId: string, rustdeskPassword?: string): Promise<void> => {
  await publicApi.post(`/support/${uuid}/rustdesk-id`, {
    rustdesk_id: rustdeskId,
    rustdesk_password: rustdeskPassword || null,
  });
};

export const sendTypingIndicator = async (uuid: string): Promise<void> => {
  await publicApi.post(`/support/${uuid}/typing`).catch(() => {});
};

export const getLauncherUrl = (uuid: string, platform: 'windows' | 'macos' = 'windows'): string => {
  return `${PUBLIC_BASE}/support/${uuid}/launcher?platform=${platform}`;
};
